<script>
import { mapActions } from 'vuex';

export default {
  name: 'SkistarAddonAccommodations',
  props: {
    id: {
      type: Number,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    accommodations: {
      type: Object,
      required: true,
    },
    show: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    showAccommodations: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    sortedAccommodations() {
      return [...this.accommodations].sort(
        (a, b) => (a.name + a.description > b.name + b.description ? 1 : -1),
      );
    },
  },
  methods: {
    ...mapActions({
      close: 'skistar/closeAddonAccommodationModal',
    }),
  },
};
</script>

<template>
  <v-layout>
    <v-flex xs12 class="text-xs-right">
      <v-dialog
        v-model="showAccommodations"
        @input="close"
        width="1000"
      >
        <v-card tile>
          <v-layout row>
            <v-flex>
              <div class="pt-3 pl-3 font-weight-bold">
                {{ description }}
              </div>
              <div class="pl-3"><small>( {{ id }} )</small></div>
            </v-flex>
            <v-flex>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  @click="close"
                  color="red darken-1"
                  flat
                >
                  Close
                </v-btn>
              </v-card-actions>
            </v-flex>
          </v-layout>
          <v-card-text>
            <div
              v-for="accommodation in sortedAccommodations"
              :key="accommodation.id"
            >
              {{ accommodation.name }}, <small>{{ accommodation.description }}</small>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>



// WEBPACK FOOTER //
// src/components/ski/skistar/SkistarAddonAccommodations.vue